import { FC } from "react";
import { defaultProfileImage } from "../../../../../../utils/constants";

/**
 * Card de la contraparte del hilo: el experto ve al miembro y el miembro ve al experto.
 *
 * Reutiliza el marcado y los estilos de `members-page__member-card` (MemberSearchList), que ya
 * implementa exactamente este diseno — foto, gradiente de abajo hacia arriba, badge entre lineas y
 * nombre en Cormorant. Duplicarlo habria dejado dos definiciones de la misma card.
 */
type Props = {
    name?: string | null;
    avatar?: string | null;
    /** Etiqueta entre las dos lineas: MEMBER o EXPERT segun a quien se este viendo. */
    badge?: string;
}

const Divider = () => (
    <svg width="14" height="1" viewBox="0 0 14 1" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M0 0.25H13.5" stroke="white" strokeWidth="0.5" />
    </svg>
);

export const ExpertisePartyCard: FC<Props> = ({ name, avatar, badge = 'Member' }) => {
    const displayName = name || 'Member';

    return (
        <div className="members-page__member-card expertise-party-card">
            <img
                src={avatar || defaultProfileImage}
                alt={displayName}
                className="members-page__member-image"
                onError={(e) => { e.currentTarget.src = defaultProfileImage }}
            />

            <div className="members-page__member-overlay-default">
                <div className="members-page__member-badge">
                    <Divider />
                    {badge}
                    <Divider />
                </div>
                <div className="members-page__member-name">{displayName}</div>
            </div>
        </div>
    );
}

export default ExpertisePartyCard;
